import { QuestionCircleOutlined } from '@ant-design/icons';
import { Collapse, Tooltip } from 'antd';
import classNames from 'classnames';
import type { ReactNode } from 'react';
import React from 'react';

import { RetrieveImage } from 'app/components/pages/Extranet/commons/RetrieveImage/RetrieveImage';
import type { PictureView } from 'app/typings/core/common/pictureView/pictureView';

import styles from './CollapseTable.module.scss';

const { Panel } = Collapse;

type CollapseTableProps = {
  title: string;
  images?: PictureView[];
  children: React.ReactNode;
  className?: string;
  keyPanel: string;
  extraHeader?: ReactNode;
  collapsible?: boolean;
  hasInfo?: boolean;
  isClosed?: boolean;
  info?: React.ReactNode;
};

export const CollapseTable = ({
  title,
  images,
  children,
  className,
  keyPanel,
  extraHeader,
  collapsible = true,
  hasInfo = false,
  isClosed = false,
  info,
}: CollapseTableProps) => {
  return (
    <Collapse
      defaultActiveKey={isClosed ? undefined : keyPanel}
      className={classNames(styles.collapseTable, className)}
      key={`collapse_${keyPanel}`}
    >
      <Panel
        header={
          <div className={styles.collapseTableHeader}>
            <div className={styles.headerImage}>
              <RetrieveImage
                images={images as [PictureView, PictureView, PictureView]}
              />
            </div>
            <span className={styles.headerTitle}>{title}</span>
            {hasInfo && info && (
              <Tooltip title={info}>
                <QuestionCircleOutlined className={styles.infoIcon} />
              </Tooltip>
            )}
          </div>
        }
        className="mainCollapseTablePanel"
        forceRender
        showArrow={collapsible}
        collapsible={collapsible ? undefined : 'disabled'}
        extra={extraHeader}
        key={keyPanel}
      >
        {children}
      </Panel>
    </Collapse>
  );
};
